import React, { useState } from 'react';
import { ApiResponseObject } from '@api/v4/ApiResponseTypes';
import { BackendPortalCard } from '@api/v4/private/PortalCardTypes';
import { PrimaryButton } from '@components/library/button/index';
import Tile from './tile';
import TileForm from './tile_form';

interface TileProps {
  editMode: boolean;
  tiles: ApiResponseObject<BackendPortalCard>[];
  triggerCardsRefresh: () => void;
}

const Tiles: React.FunctionComponent<TileProps> = ({
  editMode,
  tiles,
  triggerCardsRefresh
}) => {
  const [showTileForm, setShowTileForm] = useState(false);
  const toggleTileForm = (): void => setShowTileForm((prevState) => !prevState);

  /* eslint-disable @typescript-eslint/camelcase */
  return (
    <section className={`tiles ${!editMode ? 'preview-mode' : ''}`}>
      {tiles.map((tile, i) => {
        const { description, image_url, display_width, link_url, name } = tile.attributes;
        return (
          <Tile
            description={description}
            displayWidth={display_width}
            draggedIndex={i}
            editMode={editMode}
            imageUrl={image_url}
            key={tile.id}
            linkUrl={link_url}
            name={name}
            portalCardId={tile.id}
            triggerCardsRefresh={triggerCardsRefresh}
          />
        );
      })}
      {editMode && (
        <div className="tiles__item tiles__item--one-third-width edit-mode">
          <PrimaryButton
            className="tile-create-button"
            icon="bff-plus"
            onClick={toggleTileForm}
          >
            {t("Create Tile")}
          </PrimaryButton>
        </div>
      )}
      {showTileForm
        && (
          <TileForm
            closeModal={toggleTileForm}
            triggerCardsRefresh={triggerCardsRefresh}
          />
        )
      }
    </section>
  );
  /* eslint-enable @typescript-eslint/camelcase */
};

export default Tiles;
